module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "formForReadPoint",
    attrs: {
      "label-width": "60px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "讲解者: "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": _vm.doWhatTemp === 'view',
      "placeholder": ""
    },
    model: {
      value: (_vm.contentInfo.artist),
      callback: function($$v) {
        _vm.$set(_vm.contentInfo, "artist", $$v)
      },
      expression: "contentInfo.artist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原音："
    }
  }, [_c('div', {
    staticClass: "flex_row_start_center"
  }, [_c('el-upload', {
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "action": "/aries-api/resource/upload",
      "data": _vm.uploadData,
      "accept": "audio/mp3",
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.handleAudioSuccess,
      "show-file-list": false,
      "disabled": _vm.doWhat === 'view'
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhat === 'view'
    }
  }, [_vm._v("\n                   上传原音\n            "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1), _vm._v(" "), (_vm.pointEditor.audio != '') ? _c('AudioPlayer', {
    attrs: {
      "audioUrl": _vm.pointEditor.audio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pointEditor.duration != null) ? _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("时长：" + _vm._s(_vm.pointEditor.duration) + "秒")]) : _vm._e(), _vm._v(" "), (_vm.pointEditor.audio != '') ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": _vm.doWhat == 'view',
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.delAudio
    }
  }, [_vm._v("删除音频")]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "讲解："
    }
  }, [_c('div', {
    staticClass: "flex_row_start_center"
  }, [_c('el-upload', {
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "action": "/aries-api/resource/upload",
      "data": _vm.uploadData,
      "accept": "audio/mp3",
      "before-upload": _vm.handleBeforeUpload,
      "on-success": _vm.handleExplainAudioSuccess,
      "show-file-list": false,
      "disabled": _vm.doWhat === 'view'
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "123px",
      "height": "35px"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.doWhat == 'view'
    }
  }, [_vm._v("\n            上传讲解\n            "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1), _vm._v(" "), (_vm.pointEditor.explainAudio != '') ? _c('AudioPlayer', {
    attrs: {
      "audioUrl": _vm.pointEditor.explainAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pointEditor.explainAudioDuration != null) ? _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("时长：" + _vm._s(_vm.pointEditor.explainAudioDuration) + "秒")]) : _vm._e(), _vm._v(" "), (_vm.pointEditor.explainAudio != '') ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small",
      "disabled": _vm.doWhat == 'view',
      "icon": "el-icon-delete"
    },
    on: {
      "click": _vm.delExplainAudio
    }
  }, [_vm._v("删除音频")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73834a8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addBook/PointInteract.vue
// module id = 712
// module chunks = 1